import { h as isObjectLike_1, j as _baseGetTag, k as _Symbol, l as isArray_1, e as getDefaultExportFromCjs, m as inStockFilter, n as collectionsURLFilter, o as discountPercentageFilter, p as colorFilter, q as sizeFilter, r as brandFilter, t as priceFilter } from './api-DwYP8rDS.js';

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$1;

var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol$1;

var Symbol$1 = _Symbol,
    arrayMap = _arrayMap,
    isArray = isArray_1,
    isSymbol = isSymbol_1;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString$1) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -Infinity) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$2;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$1;

var baseSlice = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

var _castSlice = castSlice$1;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$1 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboRange$1 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

var _stringToArray = stringToArray$1;

var castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray = _stringToArray,
    toString$1 = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$1(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst$1;

var toString = toString_1,
    upperFirst = upperFirst_1;

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

var capitalize_1 = capitalize;

const capitalize$1 = /*@__PURE__*/getDefaultExportFromCjs(capitalize_1);

function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }


const getFacets = (items, translations, visibleFacetsBeforeCollapse) => {
  const mappedFacets =
    _nullishCoalesce(items.reduce((acc, facet) => {
      const mappedFacet = mapFacet(facet, translations);

      if (mappedFacet) {
        acc.push(mappedFacet);
      }

      return acc;
    }, [] ), () => ( []));
  const sortedFacets = mappedFacets.reduce((acc, facet) => {
    if (facet.type === 'range') {
      acc.push(facet);
    } else {
      const facetsBeforeCollapse = facet.items.slice(0, visibleFacetsBeforeCollapse);
      const facetsAfterCollapse = facet.items.slice(visibleFacetsBeforeCollapse);
      // Sort the filter options alphabetically in ascending order for the collapsed items.
      const sortedItems = facetsAfterCollapse.sort((a, b) => (a.translation > b.translation ? 1 : -1));

      acc.push({
        ...facet,
        items: [...facetsBeforeCollapse, ...sortedItems],
      });
    }

    return acc;
  }, [] );

  return sortedFacets;
};

const mapFacet = (() => {
  // Cache the header links to avoid querying the DOM multiple times.
  let headerLinks;
  let headerLinkUrl = new URL(window.location.origin);
  // A table of the header links to avoid searching for them.
  let headerLinksMap;

  return (facet, translations) => {
    headerLinks =
      headerLinks || ([...document.querySelectorAll('#header [data-header-menu]:not([data-header-menu="brands"]) a')] );
    headerLinksMap =
      headerLinksMap ||
      headerLinks.reduce((acc, link) => {
        headerLinkUrl.pathname = _nullishCoalesce(link.getAttribute('href'), () => ( ''));
        const key = headerLinkUrl.pathname;
        const textContent = link.textContent;

        if (!acc[key] && textContent && key !== '/') {
          acc[key] = textContent;
        }

        return acc;
      }, {} );

    const val = {
      name: facet.name,
      translation: getTitleTranslation(translations, facet.name),
      type: facet.type,
      isColor: facet.name === 'base_colors',
      isSize: facet.name === 'size',
      isDiscountPercentage: facet.name === discountPercentageFilter.name,
      isPrice: facet.name === 'lowest_variant_price',
      isCollection: facet.name === collectionsURLFilter.name,
      isStock: facet.name === inStockFilter.name,
      hide: false,
      items: [],
    } ;

    if (facet.type === 'range') {
      val.items = (['min', 'max'] ).map((item) => {
        const selectedKey = `selected${capitalize$1(item)}`;
        const selectedVal = facet[selectedKey ];

        return {
          item,
          selected: selectedVal !== undefined,
          translation: _nullishCoalesce(translations[`filter${capitalize$1(item)}`], () => ( '')),
          value: facet[item],
          selectedValue: selectedVal,
        };
      });
    } else {
      const collectionUrl = new URL(window.location.origin);

      val.items =
        _nullishCoalesce(_optionalChain([facet, 'access', _ => _.items, 'optionalAccess', _2 => _2.reduce, 'call', _3 => _3((acc, item, index) => {
          const filterVal = {
            item: item.item,
            count: item.count,
            selected: item.selected,
            translation: '',
            value: item.item,
          };

          if (val.isColor && typeof item.item === 'string') {
            filterVal.translation = _nullishCoalesce(translations.colors[item.item.toLowerCase()], () => ( item.item));
          } else if (val.isCollection) {
            collectionUrl.pathname = item.item ;

            const matchedHeaderLink = headerLinksMap[collectionUrl.pathname];

            if (!matchedHeaderLink) return acc;

            filterVal.translation = matchedHeaderLink;
          } else if (val.isStock) {
            filterVal.translation = item.item ? translations.filterInStock : translations.filterOutOfStock;

            if (index === 1) {
              const isInStockItem = item.item === true;
              const inStockItem = isInStockItem ? filterVal : acc[0];
              const outOfStockItem = isInStockItem ? acc[0] : filterVal;

              // "In stock" should come first.
              acc[0] = inStockItem;
              acc[1] = outOfStockItem;

              return acc;
            }
          } else if (typeof item.item === 'string') {
            filterVal.translation = item.item;
          } else if (typeof item.item === 'number') {
            filterVal.translation = item.item.toString();
          }

          acc.push(filterVal);

          return acc;
        }, [] )]), () => ( []));
    }

    if (val.items.length === 0) return undefined;

    return val;
  };
})();

const getTitleTranslation = (translations, title) => {
  switch (title) {
    case priceFilter.name:
      return translations.filterPrice;
    case brandFilter.name:
      return translations.filterBrand;
    case sizeFilter.name:
      return translations.filterSize;
    case colorFilter.name:
      return translations.filterColor;
    case collectionsURLFilter.name:
      return translations.filterCollections;
    case discountPercentageFilter.name:
      return translations.filterDiscount;
    case inStockFilter.name:
      return translations.filterAvailable;
    default:
      return title;
  }
};

const mapFacetToRequest = ({ facet, value, selected }) => {
  if (facet.type === 'range') {
    const selectedRange = facet.items.reduce((acc, item) => {
      if (selected === false) return acc;

      if (Array.isArray(value)) {
        if (item.item === 'min') {
          const newValue = selected ? value[0] : item.selectedValue;

          if (newValue !== undefined) {
            acc.min = newValue;
          }
        }

        if (item.item === 'max') {
          const newValue = selected ? value[1] : item.selectedValue;

          if (newValue !== undefined) {
            acc.max = newValue;
          }
        }
      } else if (item.selectedValue !== undefined) {
        acc[item.item] = item.selectedValue;
      }

      return acc;
    }, {} );

    return {
      name: facet.name,
      type: facet.type,
      attributeName: facet.name,
      selected: selectedRange,
    };
  } else {
    const selectedList = facet.items.reduce((acc, item) => {
      if (value !== undefined && item.value === value) {
        if (selected) {
          acc.push(item.value);
        }
      } else if (item.selected) {
        acc.push(item.value);
      }

      return acc;
    }, [] );

    return {
      name: facet.name,
      type: facet.type ,
      attributeName: facet.name,
      selected: selectedList,
    };
  }
};

const getInitialFacets = (facets = [], options = {}) => {
  const { templateSuffix } = options;
  const facetsForRequest = [...facets];

  switch (templateSuffix) {
    case 'loop-only-filters':
      facetsForRequest.unshift(collectionsURLFilter);
      break;
  }

  return facetsForRequest;
};

export { getFacets as a, getInitialFacets as g, isSymbol_1 as i, mapFacetToRequest as m };
